/**
 * Yalıda Davet · centralised data-testid constants.
 * Imported by React components AND Playwright specs so selectors can
 * never drift apart.
 */
export const TID = {
  // Global navigation
  navbar: 'navbar',
  navLogo: 'nav-logo',
  navHome: 'nav-home',
  navListings: 'nav-listings',
  navMessages: 'nav-messages',
  navProfile: 'nav-profile',
  navFavorites: 'nav-favorites',
  navSignIn: 'nav-signin',
  navAvatar: 'nav-avatar',
  navMobileToggle: 'nav-mobile-toggle',

  // Hero search
  heroSearch: 'hero-search',
  searchLocation: 'search-location',
  searchDate: 'search-date',
  searchCheckin: 'search-checkin',
  searchCheckout: 'search-checkout',
  searchPropertyType: 'search-property-type',
  searchGuests: 'search-guests',
  searchSubmit: 'search-submit',
  quickFilter: (id: string) => `quick-filter-${id}`,
  quickFilters: 'quick-filters',

  // Landing
  popularVenues: 'popular-venues',
  popularVenuesAll: 'popular-venues-see-all',

  // Search results
  stickySearch: 'sticky-search',
  stickySearchUpdate: 'sticky-search-update',
  filtersPanel: 'filters-panel',
  filterPriceMin: 'filter-price-min',
  filterPriceMax: 'filter-price-max',
  filterPriceSliderMin: 'filter-price-slider-min',
  filterPriceSliderMax: 'filter-price-slider-max',
  filterAreaMin: 'filter-area-min',
  filterAreaMax: 'filter-area-max',
  filterAreaSliderMin: 'filter-area-slider-min',
  filterAreaSliderMax: 'filter-area-slider-max',
  filterAmenity: (key: string) => `filter-amenity-${key}`,
  filterApply: 'filters-apply',
  filterReset: 'filters-reset',
  resultsCount: 'results-count',
  resultsGrid: 'results-grid',
  sortSelect: 'sort-select',
  mansionCard: (id: string) => `mansion-card-${id}`,
  mansionCardAny: 'mansion-card',
  cardFavorite: (id: string) => `card-favorite-${id}`,
  cardPrice: 'card-price',
  cardRating: 'card-rating',
  cardEventTag: 'card-event-tag',
  emptyState: 'results-empty',

  // Property detail
  gallery: 'property-gallery',
  galleryAll: 'property-gallery-all',
  aboutSection: 'property-about',
  amenityList: 'property-amenities',
  eventTypesSection: 'property-event-types',
  hostRuleWarning: 'property-host-rule-warning',

  // Booking widget
  bookingWidget: 'booking-widget',
  bookingPriceHeader: 'booking-price-header',
  bookingCheckin: 'booking-checkin',
  bookingCheckout: 'booking-checkout',
  bookingGuestStepper: 'booking-guest-stepper',
  bookingGuestDec: 'booking-guest-decrement',
  bookingGuestInc: 'booking-guest-increment',
  bookingGuestValue: 'booking-guest-value',
  /** Alias for the numeric guest input (E2E types directly into it). */
  bookingGuests: 'booking-guest-value',
  bookingEventType: 'booking-event-type',
  bookingAddon: (code: string) => `booking-addon-${code}`,
  bookingTotal: 'booking-total',
  bookingDeposit: 'booking-deposit',
  bookingLine: 'booking-line',
  bookingSubmit: 'booking-submit',
  bookingContactHost: 'booking-contact-host',
  bookingBlocker: 'booking-blocker',
  noiseWarning: 'booking-noise-warning',
  checkoutDeadline: 'booking-checkout-deadline',
  /** Alias used by the booking specs for the hard-stop checkout notice. */
  bookingCheckoutDeadline: 'booking-checkout-deadline',

  // Host flow
  hostStepper: 'host-stepper',
  hostStep: (n: number) => `host-step-${n}`,
  hostNext: 'host-next',
  hostBack: 'host-back',
  hostSubmit: 'host-submit',
  hostDropzone: 'host-dropzone',
  hostPhotoPreview: 'host-photo-preview',
  hostDailyPrice: 'host-daily-price',
  hostWeekendPrice: 'host-weekend-price',
  hostCapacity: 'host-capacity',
  hostGardenSize: 'host-garden-size',
  hostEventToggle: (id: string) => `host-event-toggle-${id}`,
  hostDocUpload: (type: string) => `host-doc-${type}`,
  hostGardenWarning: 'host-garden-warning',

  // Messaging
  chatSidebar: 'chat-sidebar',
  chatSearch: 'chat-search',
  chatConversation: (id: string) => `chat-conversation-${id}`,
  chatUnreadBadge: 'chat-unread-badge',
  chatWindow: 'chat-window',
  chatHeader: 'chat-header',
  chatCall: 'chat-call',
  chatOptions: 'chat-options',
  chatSecurityBanner: 'chat-security-banner',
  chatDateDivider: 'chat-date-divider',
  chatMessage: 'chat-message',
  chatInput: 'chat-input',
  chatAttach: 'chat-attach',
  chatSend: 'chat-send',
} as const;
